import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'
import { get, set } from 'idb-keyval'
import SvgIcon from 'components/atoms/SvgIcon'

interface IProps {
  children: React.ReactChild
  title?: string | React.ReactNode
  stateKey?: string | number
  defaultOpen?: boolean
}

const setAccodionState = async (stateKey: string, open: boolean) => {
  await set(stateKey, open)
}

const getAccodionState = async (stateKey: string) => {
  const value = await get(stateKey)
  return value
}

const ExpandSection: React.VFC<IProps> = ({ children, title, stateKey, defaultOpen = true }) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(defaultOpen)
  const [initialized, setInitialized] = React.useState<boolean>(false)

  React.useEffect(() => {
    const initialize = async () => {
      if (stateKey) {
        const initState = await getAccodionState(stateKey.toString())
        if (typeof initState === 'boolean') {
          setIsOpen(initState)
        }
      }
      setInitialized(true)
    }
    initialize()
  }, [])

  const toggle = () => {
    setIsOpen(old => {
      if (stateKey) {
        setAccodionState(stateKey.toString(), !old)
      }
      return !old
    })
  }

  return (
    <Expand>
      <div className="head" onClick={toggle}>
        {initialized && (
          <div className="toggle">
            <SvgIcon name={isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'} className="icon" />
          </div>
        )}
        {!initialized && (
          <SvgIcon name="sync" className="icon" ariaHidden={true} role="presentation" />
        )}

        {title && title}
      </div>
      {initialized && <div className={`expandChild ${isOpen ? 'open' : 'close'}`}>{children}</div>}
    </Expand>
  )
}

const Expand = styled.div`
  .head {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    &:hover {
      color: ${constants.COLORS.primary};
    }
  }
  .toggle {
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
  .expandChild {
    overflow: hidden;
    transition: all 0.2s;
    &.open {
      overflow: auto;
      padding-top: 16px;
    }
    &.close {
      max-height: 0;
      padding-top: 0;
    }
  }
`

export default ExpandSection
